module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("Dedicated to")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', [_vm._v("Sgt. Eric M. Holke of the California Army National Guard")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("7/11/76–7/15/07")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', [_vm._v("Wish you were here.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f44f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Unincorporated_dedi-1.vue
// module id = 75
// module chunks = 0